import React from "react";

const PreviewJsonFormat = ({ formatJson, setShowModal }) => {

const closeModal = () => {
  setShowModal(false)
}


  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-lg shadow-lg w-[500px] h-[600px] flex flex-col justify-between">
          <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
           Json Format
          </h3>
          {/* Top content */}
          <div className="p-4 flex-1 overflow-auto scrollbar-hidden">
          <textarea
            rows={18}
            name="formatJson"
             className="border border-gray-800 p-2 w-full"
             value={formatJson}
             disabled
          />
          </div>

          {/* Footer */}
          <div className="flex justify-end p-4 border-t">
            <button
              onClick={closeModal}
              className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewJsonFormat;
